export default __webpack_public_path__ + "a2466d23cd5fb57749ddde6cb6e31e98.png";